import React, { FC, useState } from "react"

import styles from "./XModal.module.scss"
import {XIcons} from "../XIcons"

export type XModalProps = {
  children: any
  visible: boolean
  theme?: string
  maxWidth?: string
  closable?: boolean
  onClose: () => void
}

type ModalExtensions = {
  Body: typeof Body
  Footer: typeof Footer
}

type FooterExtensions = {
  Button: typeof FooterButton
}

export const XModal: FC<XModalProps> & ModalExtensions = ({
  children, visible, theme = "light", maxWidth = "550px", closable = true, onClose
}) => {

  const [ hidingProceed, setHidingProceed ] = useState(false)

  const onKeydown = ({ key }: KeyboardEvent) => {
    switch (key) {
      case 'Escape':
        if (closable) {
          setHidingProceed(true)
          setTimeout(() => {
            onClose()
            setHidingProceed(false)
          }, 300)
        }
        break
    }
  }

  const onCloseRef = () => {
    setHidingProceed(true)
    setTimeout(() => {
      onClose()
      setHidingProceed(false)
    }, 300)
  }

  React.useEffect(() => {
    document.addEventListener('keydown', onKeydown)
    return () => document.removeEventListener('keydown', onKeydown)
  })

  if (!visible) return null

  return (
    <>
      <div className={styles.modal + (theme == "dark" ? " " + styles.dark : "")} id="mdx_ex" style={{opacity: hidingProceed ? "0" : "1"}}>
        <div className={styles.modal_dialog} style={{maxWidth: maxWidth}} onClick={e => e.stopPropagation()}>
          <div className={styles.modal_header}>
            <span style={{display: closable ? "block" : "none"}} className={styles.modal_header__close} onClick={onCloseRef}>
              <XIcons name="s times" color="rgba(255, 255, 255, 0.5)" size="14px" />
            </span>
          </div>
          <div className={styles.modal_body}>
            <div className={styles.modal_body__content}>{children}</div>
          </div>
        </div>
      </div>
    </>
  )
}

type BodyProps = {
  children: any
}

type FooterProps = {
  children: any
  justify?: string
}

type FooterButtonProps = {
  children: any
  onClick: (ev: any) => void
  primary?: boolean
  disabled?: boolean
  style?: any
  closer?: boolean
}

type BodyExtensions = {
  Title: typeof Title
}

const Body: FC<BodyProps> & BodyExtensions = ({ children }) => {
  return (
    <>
      {children}
    </>
  )
}

const Footer: FC<FooterProps> & FooterExtensions = ({
  children, justify = "flex-end"
}) => {
  return (
    <>
      <div className={styles.footer_actions} style={{
        justifyContent: justify
      }}>
        {children}
      </div>
    </>
  )
}

const FooterButton: FC<FooterButtonProps> = ({ 
  children, onClick, primary = false, disabled = false, style = {}, closer = false
}) => {
  return (
    <>
      <button 
        disabled={disabled} 
        className={(primary ? styles.primary : "") + (disabled ? " " + styles.disabled : "")} 
        style={style}
        onClick={onClick}>{children}</button>
    </>
  )
}

type TitleProps = {
  children?: any
}

const Title: FC<TitleProps> = ({ children }) => {
  return (
    <>
      <h3>{children}</h3>
    </>
  )
}

XModal.Body = Body
Body.Title = Title
XModal.Footer = Footer
Footer.Button = FooterButton